import Page from "@jumbo/shared/Page";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import Generate from "./generate";
import MyList from "./myList";
import Admin from "./Admin.js";
import { Navigate } from "react-router-dom";
import { isCrowellTenant } from "app/utils/tenantUtils";

const isCrowell = isCrowellTenant();

const FileNumberGenerator_routes = [
   
    {
        path: ["/file-number-generator","/file-number-generator/generate"],
        element: isCrowell ? <TenantAdminRoute element ={<Page component={Generate}/>} /> : <Navigate to="/dashboard" replace />
    },
    {
        path: ["/file-number-generator/my-list"],
        element: isCrowell ? <TenantAdminRoute element={<Page component={MyList} />} /> : <Navigate to="/dashboard" replace />
    },
    {
        path: ["/file-number-generator/admin"],
        element: isCrowell ? <TenantAdminRoute element={<Page component={Admin} />} /> : <Navigate to="/dashboard" replace />
    }
    
];

export default FileNumberGenerator_routes;